import { useMemo } from "react";
import { getRoom } from "../../components/Twilio/Room/roomService";
import useParticipants from "../useParticipants/useParticipants";
import { CALL_DATA } from "../../constants/PublicVariables";
import { isSilentObserver } from "../../shared/utility";

export const useParticipantCounts = () => {
    const room = getRoom();
    const participants = useParticipants();

    const totalUserCount = useMemo(() => {
        const totalParticipants = room?.participants?.size || 0;
        const isLocalSilentObserver = isSilentObserver(CALL_DATA.localIdentity);

        const silentObserversCount = Array.from(room?.participants?.values() || []).filter((participant) =>
            isSilentObserver(participant.identity)
        ).length;

        const countWithSilentObserver = totalParticipants + 1;
        const countWithoutSilentObserver = isLocalSilentObserver
            ? totalParticipants - silentObserversCount
            : totalParticipants + 1 - silentObserversCount;

        return {
            countWithSilentObserver,
            countWithoutSilentObserver,
        };
    }, [room, participants]);

    return totalUserCount;
};
